import { createStructuredSelector } from 'reselect'

import {
  CODE22_LIST,
  CODE22_LIST_SUCCESS,
  CODE22_LIST_ERROR,
  CODE22_SEARCH_DISPENSING_UNIT_LIST,
  CODE22_SEARCH_DISPENSING_UNIT_LIST_SUCCESS,
  CODE22_SEARCH_DISPENSING_UNIT_LIST_ERROR,
  CODE22_SEARCH_SET,
  CODE22_PAGE_SET,
  CODE22_VIEW_MODAL_SET,
  CODE22_VIEW_TAB_SET,
  CODE22_SEARCH_CHANGE,
  CODE22_HEADER,
  CODE22_SEARCH_ATC5_LIST,
  CODE22_SEARCH_ATC5_LIST_SUCCESS,
  CODE22_SEARCH_ATC5_LIST_ERROR,
  CODE22_SEARCH_YEAR_LIST,
  CODE22_SEARCH_YEAR_LIST_SUCCESS,
  CODE22_SEARCH_YEAR_LIST_ERROR,
  CODE22_SEARCH_CODE22_TYPE_LIST,
  CODE22_SEARCH_CODE22_TYPE_LIST_SUCCESS,
  CODE22_SEARCH_CODE22_TYPE_LIST_ERROR,
  CODE22_DETAIL,
  CODE22_DETAIL_SUCCESS,
  CODE22_DETAIL_ERROR,
  CODE22_SEARCH_DEMAND_LIST,
  CODE22_SEARCH_DEMAND_LIST_SUCCESS,
  CODE22_SEARCH_DEMAND_LIST_ERROR,
} from '../actions';

export const NAME = 'code22';

export const Code22List = (page, num_page, orderBy, filters, stateFilter) => ({
  type: CODE22_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const Code22ListSuccess = (data) => ({
  type: CODE22_LIST_SUCCESS,
  payload: data
});

export const Code22ListError = (error) => ({
  type: CODE22_LIST_ERROR,
  payload: error
});

export const Code22SearchDispensingUnitList = () => ({
  type: CODE22_SEARCH_DISPENSING_UNIT_LIST
});

export const Code22SearchDispensingUnitListSuccess = (data) => ({
  type: CODE22_SEARCH_DISPENSING_UNIT_LIST_SUCCESS,
  payload: data
});

export const Code22SearchDispensingUnitListError = (error) => ({
  type: CODE22_SEARCH_DISPENSING_UNIT_LIST_ERROR,
  payload: error
});

export const Code22SearchSet = (data) => ({
  type: CODE22_SEARCH_SET,
  payload: data
});

export const Code22PageSet = (data) => ({
  type: CODE22_PAGE_SET,
  payload: data
});

export const Code22ViewModalSet = (data) => ({
  type: CODE22_VIEW_MODAL_SET,
  payload: data
});


export const Code22Header = (data) => ({
  type: CODE22_HEADER,
  payload: data
});

export const Code22ViewTabSet = (data) => ({
  type: CODE22_VIEW_TAB_SET,
  payload: data
});


export const Code22SearchChangeSet = (data) => ({
  type: CODE22_SEARCH_CHANGE,
  payload: data
});

export const Code22SearchAtc5List = () => ({
  type: CODE22_SEARCH_ATC5_LIST
});

export const Code22SearchAtc5ListSuccess = (message) => ({
  type: CODE22_SEARCH_ATC5_LIST_SUCCESS,
  payload: message
});

export const Code22SearchAtc5ListError = (error) => ({
  type: CODE22_SEARCH_ATC5_LIST_ERROR,
  payload: error
}); 

export const Code22SearchYearList = () => ({
  type: CODE22_SEARCH_YEAR_LIST
});

export const Code22SearchYearListSuccess = (message) => ({
  type: CODE22_SEARCH_YEAR_LIST_SUCCESS,
  payload: message
});

export const Code22SearchYearListError = (error) => ({
  type: CODE22_SEARCH_YEAR_LIST_ERROR,
  payload: error
}); 


export const Code22SearchCode22TypeList = () => ({
  type: CODE22_SEARCH_CODE22_TYPE_LIST
});

export const Code22SearchCode22TypeListSuccess = (message) => ({
  type: CODE22_SEARCH_CODE22_TYPE_LIST_SUCCESS,
  payload: message
});

export const Code22SearchCode22TypeListError = (error) => ({
  type: CODE22_SEARCH_CODE22_TYPE_LIST_ERROR,
  payload: error
});

export const Code22Detail = (data) => ({
  type: CODE22_DETAIL,
  payload: data
});

export const Code22DetailSuccess = (data) => ({
  type: CODE22_DETAIL_SUCCESS,
  payload: data
});

export const Code22DetailError = (error) => ({
  type: CODE22_DETAIL_ERROR,
  payload: error
});

export const Code22SearchDemandList = () => ({
  type: CODE22_SEARCH_DEMAND_LIST
});

export const Code22SearchDemandListSuccess = (message) => ({
  type: CODE22_SEARCH_DEMAND_LIST_SUCCESS,
  payload: message
});

export const Code22SearchDemandListError = (error) => ({
  type: CODE22_SEARCH_DEMAND_LIST_ERROR,
  payload: error
}); 
const code22 = (state) => state[NAME];

export const Code22Selector = createStructuredSelector({
  code22
})
